import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const WrapperStepper = styled(Box)(({ theme }) => ({
  marginBottom: '45px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '24px'
  }
}));
